import { API_BASE_URL } from '../config';

/**
 * QR Management Endpoints
 * Based on legacy API configuration
 */
export const QR_ENDPOINTS = {
  // Configuration CRUD
  getConfigList: `${API_BASE_URL}qr/getqrconfig`,
  createConfig: `${API_BASE_URL}qr/qrconfig`,
  updateConfig: `${API_BASE_URL}qr/qrconfig`, // Same endpoint as create (determined by presence of qr_id)
  
  // Generation & Import
  generateQr: `${API_BASE_URL}qr/generate-qr`, // Note: keeping typo from legacy
  importQr: `${API_BASE_URL}qr/import-config`,
  
  // List QR Codes
  getQrList: `${API_BASE_URL}qr/get-qr-list`,
  getImportedQrList: `${API_BASE_URL}qr/get-import-qr-list`,
  getQrRequestList: `${API_BASE_URL}qr/getqrrequestlist`,
  
  // Approve QR
  approveQr: `${API_BASE_URL}qr/generateqrcodes`,
  approveRequest: `${API_BASE_URL}qr/requestapproval`,
  
  // Import Job Status
  getImportJobStatus: `${API_BASE_URL}queue/file-progress-status-module-wise`,
  
  // Import Validation
  getImportValidationConfig: `${API_BASE_URL}qr/get-qr-import-validation-config`,
  validateQrImport: `${API_BASE_URL}qr/validate-qr-import`,
  importQrAsync: `${API_BASE_URL}qr/import-qr-async`,
  
  // Gap Analysis
  getQrGapAnalysis: `${API_BASE_URL}loyalty/get-qr-gap-analysis`,

  // Maker-Checker
  qrMakerCheckerAsync: `${API_BASE_URL}qr/qr-maker-checker-async`,
  getUploadPointsValidationConfig: `${API_BASE_URL}qr/get-upload-points-validation-config`,
  validateUploadPoints: `${API_BASE_URL}qr/validate-upload-points`,
  uploadPointsAsync: `${API_BASE_URL}qr/upload-points-async`,
  rejectPoints: `${API_BASE_URL}qr/reject-points`,
} as const;
